import { IClaioImageSource } from "../../../domain/claio";
import { ImageSourceKinds } from "../../../domain/document/ImageSourceKinds";
import { AbstractClaioImageSource } from "./AbstractClaioImageSource";

export class ClaioImageSource extends AbstractClaioImageSource {
  constructor(
    getToken: () => string,
    patientId: string,
    claioImageKey: string,
    imageGuid: string,
    imageSourceKind: ImageSourceKinds,
    isMovie: boolean,
    isLeft: boolean,
    isRight: boolean,
    isSecret: boolean,
    departmentId: string,
    isVisibleLayer: boolean,
    imageDate: Date,
    imageKind: string,
  ) {
    super(getToken, patientId, claioImageKey, imageGuid, imageSourceKind, isMovie, isLeft, isRight, isSecret, departmentId, isVisibleLayer, imageDate, imageKind);
  }

  public get thumbnailSource(): string {
    if (!this.claioImageKey) { return null; }
    const url = "/api/patient/" + this.patientId + "/claio/thumbnail/" + this.claioImageKey + "?token=" + this.token + "&isVisibleLayer=" + !!this.isVisibleLayer;
    console.debug("[claio thumbnail image source] " + url);
    return url;
  }

  public get originalSource(): string {
    if (!this.claioImageKey) { return null; }
    const url = "/api/patient/" + this.patientId + "/claio/image/" + this.claioImageKey + "?token=" + this.token + "&isVisibleLayer=" + !!this.isVisibleLayer;
    console.debug("[claio original image source] " + url);
    return url;
  }

  public clone(): IClaioImageSource {
    return new ClaioImageSource(
      this._getToken,
      this.patientId,
      this.claioImageKey,
      this.imageGuid,
      this._imageSourceKind,
      this.isMovie,
      this.isLeft,
      this.isRight,
      this.isSecret,
      this.departmentId,
      this.isVisibleLayer,
      this.imageDate,
      this.imageKind,
    );
  }
}
